var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { List, ListItem, ListItemText, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
/**
 * Nested bullet list of exceeded seat-capacity locations (available vs required).
 * Shared by the lock-gate warning and the Seats Alert Details dialog.
 */
export var SeatCapacityLocationsList = function (_a) {
  var locations = _a.locations,
    intro = _a.intro;
  var t = useTranslation('translation').t;
  var introText = intro !== null && intro !== void 0 ? intro : t('confirmation.seatCapacityIntro');
  return _jsxs(Typography, __assign({
    component: "div",
    sx: {
      color: 'text.primary'
    }
  }, {
    children: [_jsx(Typography, __assign({
      component: "p",
      sx: {
        mb: 1
      }
    }, {
      children: introText
    })), _jsx(List, __assign({
      dense: true,
      disablePadding: true,
      component: "ul",
      sx: {
        listStyleType: 'disc',
        pl: 3
      }
    }, {
      children: locations.map(function (loc) {
        return _jsx(ListItem, __assign({
          disableGutters: true,
          sx: {
            display: 'list-item',
            py: 0.25
          }
        }, {
          children: _jsx(ListItemText, {
            disableTypography: true,
            primary: _jsx(Typography, __assign({
              component: "span",
              sx: {
                fontWeight: 700
              }
            }, {
              children: loc.locationName
            })),
            secondary: _jsxs(List, __assign({
              dense: true,
              disablePadding: true,
              component: "ul",
              sx: {
                listStyleType: 'circle',
                pl: 3
              }
            }, {
              children: [_jsx(ListItem, __assign({
                disableGutters: true,
                sx: {
                  display: 'list-item',
                  py: 0
                }
              }, {
                children: _jsx(ListItemText, {
                  primary: t('confirmation.seatsAvailable', {
                    count: loc.available
                  })
                })
              })), _jsx(ListItem, __assign({
                disableGutters: true,
                sx: {
                  display: 'list-item',
                  py: 0
                }
              }, {
                children: _jsx(ListItemText, {
                  primary: t('confirmation.seatsRequired', {
                    count: loc.required
                  })
                })
              }))]
            }))
          })
        }), loc.locationId);
      })
    }))]
  }));
};